export default __webpack_public_path__ + "static/media/240.f638ac47.png";